import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gSteps from "@/components/g-steps/g-steps.vue";
import gButton from '@/components/g-button/g-button.vue'

import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import AccountLoged from "@/shared/mixins/AccountLoged";



const name = 'ProdutoRepeticaoInicio'
export default {
  name,

  components: {
    'g-card': gCard,
    'g-form': gForm,
    'g-button' : gButton,
    'g-steps' : gSteps
   },

  props: { },

  mounted () {
    this.popularDropDownEmpresa()



    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
   },

  updated () { },

  data () {
    return {
      RepresentanteSelecionado:null,
      RepresentantesArray:[],

      ClienteSelecionado:null,
      ClientesArray:[],

      EmpresaSelecionada:null,
      EmpresaArray:[],
      PrdodutoId:null,
      OrcamentoId:null,
      CidadeId:null,
      escritobotao: true,
      largura: "240px",
      timer: null,
    }
  },

  mixins:[AccountLoged],

  methods: {
    procurarRepresentante(){
      this.popularDropDownRepresentante()
    },

    atualizaEmpresaRepresentante(){
      this.RepresentantesArray = this.$store.state.RepresentanteArray;
      this.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;
      this.RepresentanteSelecionado = this.$store.state.representanteSelecionadoId;
    },

    continuar() {
      if(this.ClienteSelecionado != null && this.RepresentanteSelecionado != null && this.EmpresaSelecionada != null){
        this.gerarOrcamentoNovo()
      }
    },
    paginainicial(){
      this.$emit('voltarinicio');
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClientesArray = ClienteController.getClienteByEmpresaRepresentanteNome(this.EmpresaSelecionada, this.RepresentanteSelecionado, event).ClientesArray;
      }, 1000);
    },

    buscarRepresentante(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.RepresentantesArray = RepresentanteController.getRepresentanteByPesquisaEUsuario(event).RepresentanteArray;
      }, 1000);
    },

    popularDropDownRepresentante(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Representante/GetRepresentanteByCliente/${this.ClienteSelecionado}`,

      })
        .then((response) => {
          this.RepresentantesArray = response.data.data
        })
        .catch(() => {
        });
    },

    popularDropDownCliente(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'Cliente/get',
      })
        .then((response) => {
          this.ClientesArray = response.data.data
        })
        .catch(() => {
        });
    },

    popularDropDownEmpresa(){
      EmpresaController.getEmpresasAtivas().requisicao
      .then(res => {
        this.EmpresaArray = res.data.data
        this.atualizaEmpresaRepresentante();
      });
    },

      zerarcampos(){
        this.RepresentanteSelecionado = null;
        this.ClienteSelecionado = null;
      },

      gerarOrcamentoNovo(){
          this.axios({
            method: 'post',
            url: process.env.VUE_APP_WEB_API + 'Cliente/GetByCliente',
            data: {
            Id: this.ClienteSelecionado,
            }
          })
            .then((response) => {
              if(response.data.data === null) {
                return

              }else{
                this.CidadeId = response.data.data[0].cidadeId

                this.escritobotao = false
                this.largura = "35px"

                  setTimeout(() => {
                  this.axios({
                    method: 'post',
                    url: process.env.VUE_APP_WEB_API + 'orcamento/post',
                    data: {
                      ClienteId: this.ClienteSelecionado,
                      RepresentanteId: this.RepresentanteSelecionado,
                      EmpresaId: this.EmpresaSelecionada,
                      Cidadeid:this.CidadeId,
                      TipoFluxoOrcamento: 1,
                    }
                  })
                    .then((response) => {

                      if(response.data.data === null) {

                        return
                      }else{
                        this.OrcamentoId = response.data.data
                      }
                      this.$router.push(`/produto-repeticao/${this.OrcamentoId}/Informacao-Cliente-Repeticao`)

                    })
                    .catch(() => {

                    });
                  } , 1100)
              }
            })
            .catch(() => {
            });

    },
   },

  computed: { },

};